module.exports = __webpack_public_path__ + "img/activities-16.3398c777.jpg";